type KnowledgeDocumentsPlainHeaderProps = {
  label: string;
  className?: string;
};

export function KnowledgeDocumentsPlainHeader({
  label,
  className,
}: KnowledgeDocumentsPlainHeaderProps) {
  return (
    <th scope="col" className={className}>
      <div className="knowledge-database__table-header">
        <span>{label}</span>
      </div>
    </th>
  );
}
